<template>
  <div v-loading="loading" class="business-income-list-container">
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-form :model="query" size="mini" inline>
          <el-form-item>
            <el-date-picker
                v-model="query.date_range"
                type="monthrange"
                align="right"
                unlink-panels
                format="yyyy年MM月"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                style="width: 240px"
                :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="query.exec_timestamp"
                            type="month"
                            format="yyyy年MM月"
                            value-format="yyyy-MM"
                            placeholder="搜索月份"
                            style="width: 140px"
            />
          </el-form-item>
          <el-form-item>
            <select-artist :value.sync="query.artist_id" style="width: 100%"/>
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.agent_name" placeholder="经纪人" clearable/>
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.order_no" placeholder="订单编号" clearable/>
          </el-form-item>
          <el-form-item>
            <select-brand :value.sync="query.brand_id"/>
          </el-form-item>
          <el-form-item>
            <company-select :company-id.sync="query.company_id"/>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_notify" placeholder="通知状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已通知" value="Y"></el-option>
              <el-option label="未通知" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_confirm" placeholder="确认状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已确认" value="Y"></el-option>
              <el-option label="未确认" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <export-by-page :tableName="tableName" module="BUSINESS_INCOME" type="text" :search="query"/>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" icon="el-icon-refresh" @click="handleRunScript">刷新数据
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="mini" icon="el-icon-message" @click="handleNotifyAgent"
                       :disabled="pageSelectedList.length === 0">
              通知经纪人
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" size="mini" icon="el-icon-edit-outline" @click="openBatchRateDialog"
                       :disabled="pageSelectedList.length === 0">
              批量修改分成比例
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>     <!--    广告订单列表表格  -->
      <div ref="tblDiv">
        <BusinessIncomeTable ref="refTableIsBiOrder"
                             :query-params.sync="query"
                             :need-operate="false"
                             @refreshOrderList="getOrdersList"
                             @handleSelectionChange="handleSelectionChange"
                             @goDetail="goDetail" :selected-data.sync="pageSelectedList"
                             @clearData="clearData">
        </BusinessIncomeTable>
      </div>

    <!-- 通知经纪人弹框 -->
    <el-dialog
        title="通知经纪人"
        :visible.sync="notifyDialogVisible"
        width="800px"
        :close-on-click-modal="false">
      <el-table :data="pageSelectedList" border style="width: 100%">

        <el-table-column prop="artist_nickname" label="红人名称" width="130"></el-table-column>
        <el-table-column prop="agent_name" label="经纪人" width="90"></el-table-column>
        <el-table-column label="订单编号" align="right" width="120">
          <template v-slot="{ row }">
            <to-order-detail by-field="order_no" :order="{ order_no: row.order_no }"/>
          </template>
        </el-table-column>
        <el-table-column prop="adv_revenue" label="广告收入" width="120" align="right">
          <template slot-scope="scope">
            <b>
              ￥ {{ $utils.numberFormat(scope.row.adv_revenue || 0, 2) }} 元
            </b>
          </template>
        </el-table-column>

      </el-table>
      <div style="margin-top: 20px; text-align: right; font-weight: bold;">
        总计广告收入：￥{{ moneyFormat(notifyTotalAmount) }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="notifyDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmNotify" :loading="notifyLoading">确认通知</el-button>
      </div>
    </el-dialog>

    <!-- 批量修改分成比例弹框 -->
    <el-dialog
        title="批量修改分成比例"
        :visible.sync="batchRateDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        @closed="batchRateForm.rate = null">
      <el-form label-width="110px">
        <el-form-item label="勾选订单数">
          <span style="font-weight: bold; color: #409EFF;">{{ pageSelectedList.length }}</span> 条
        </el-form-item>
        <el-form-item label="分成比例(%)" required>
          <el-input-number v-model="batchRateForm.rate" :min="0" :max="100" :precision="2" :step="1"
                           controls-position="right" placeholder="请输入分成比例" style="width: 200px"/>
        </el-form-item>
      </el-form>
      <div style="color: #909399; font-size: 12px;">
        将按所选订单各自的“实际所得”自动计算红人所得、公司所得，并为每个订单写入修改日志。
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchRateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchRate" :loading="batchRateLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 全局方法

import SelectArtist from "@/components/Selects/artist.vue";
import SelectBrand from "@/components/Selects/brand.vue";
import {businessIncomeExportList, businessIncomeList, businessIncomeRunScript, notifyAgent} from "@/api/incomeSummary";
import {batchEditOrderRate} from "@/api/order";
import moment from "moment/moment";
import BusinessIncomeTable from "./table/BusinessIncomeTable.vue";
import ExportByPage from "../../../../components/export/ByPage/index.vue";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";

export default {
  name: "BusinessIncomeIndex",
  components: {
    ToOrderDetail,
    CompanySelect,
    ExportByPage,
    BusinessIncomeTable,
    SelectArtist,
    SelectBrand,
  },
  data() {
    return {
      tableName: 'business_income_table',
      loading: false,
      tableData: [],
      expandKeys: [],
      pageSelectedList: [],//预览数据列表
      query: {
        exec_timestamp: null,
        artist_id: null,
        agent_name: null,
        order_no: null,
        brand_id: null,
        company_id: null,
        is_notify: null,
        is_confirm: null,
        date_range: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      isColSet: false,
      topHeight: 0,
      height: null,
      // 通知经纪人相关
      notifyDialogVisible: false,
      notifyLoading: false,
      notifyForm: {
        date_check: '',
        nickname: '',
        agent_name: '',
        artist_rate_amount: ''
      },
      // 批量修改分成比例相关
      batchRateDialogVisible: false,
      batchRateLoading: false,
      batchRateForm: {
        rate: null
      }
    };
  },
  computed: {
    // 计算通知总金额
    notifyTotalAmount() {
      if (!this.pageSelectedList || this.pageSelectedList.length === 0) {
        return 0;
      }
      return this.pageSelectedList.reduce((total, item) => {
        return total + (parseFloat(item.adv_revenue) || 0);
      }, 0);
    }
  },
  created() {
    this.query.exec_timestamp = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  mounted() {
    this.topHeight = this.$refs.tblDiv.offsetTop
    this.height = Number(window.innerHeight) - Number(this.topHeight) - 230 + 'px'
  },
  methods: {

    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handleSearch: function () {
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].initList(true)
      // this.getTableData(true)
    },
    async handleRunScript() {
      let year = moment().format('YYYY')
      let month = moment().format('MM')
      if (this.query.exec_timestamp) {
        year = moment(this.query.exec_timestamp).format('YYYY')
        month = moment(this.query.exec_timestamp).format('MM')
      }

      //执行权限更新
      const string_s = `${year}年${month}月`;
      this.$confirm(
          `确定更新<b>${string_s}</b>数据吗？`,
          '更新商务收入数据',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            this.doLoading = true
            await businessIncomeRunScript({Ym: year + '-' + month, init: 1})
            this.msgSuccess('更新任务已发布，请稍后点击查询是否更新')
            setTimeout(() => {
              this.doLoading = false
            }, 500)
          })
    },
    // 通知经纪人
    handleNotifyAgent() {
      if (this.pageSelectedList.length === 0) {
        this.$message.warning('请先选择要通知的数据')
        return
      }
      this.notifyDialogVisible = true
    },
    // 确认通知
    async confirmNotify() {
      this.notifyLoading = true
      try {
        // 构建通知数据，格式为 {ids: ids, type: type}
        const ids = this.pageSelectedList.map(item => item.id)
        const notifyData = {
          ids: ids,
          type: 'business'
        }

        await notifyAgent(notifyData)

        this.$message.success({
          message:'通知发送成功',
          showClose:true
        })
        this.notifyDialogVisible = false
        // 刷新列表数据
        this.getOrdersList()
      } catch (error) {
        this.$message.error('通知发送失败：' + (error.message || '未知错误'))
      } finally {
        this.notifyLoading = false
      }
    },
    // 打开批量修改分成比例弹框
    openBatchRateDialog() {
      if (this.pageSelectedList.length === 0) {
        this.$message.warning('请先勾选要修改分成比例的订单')
        return
      }
      this.batchRateForm.rate = null
      this.batchRateDialogVisible = true
    },
    // 提交批量修改分成比例
    async submitBatchRate() {
      const rate = this.batchRateForm.rate
      if (rate === null || rate === undefined || rate === '') {
        this.$message.warning('请输入分成比例')
        return
      }
      const ids = this.pageSelectedList.map(item => item.id)
      try {
        await this.$msgbox.confirm(
            `确认将 ${ids.length} 条订单的分成比例设置为 ${rate}% 吗？将自动重算红人所得、公司所得并写入修改日志。`,
            '提示',
            {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}
        )
      } catch (e) {
        this.$message({type: 'info', message: '已取消操作'})
        return
      }
      this.batchRateLoading = true
      try {
        const res = await batchEditOrderRate({order_ids: ids, rate})
        const count = (res && res.model && res.model.count) || ids.length
        this.$message.success(`成功修改 ${count} 条订单的分成比例`)
        this.batchRateDialogVisible = false
        this.getOrdersList()
      } catch (error) {
        this.$message.error('批量修改失败：' + (error.message || '未知错误'))
      } finally {
        this.batchRateLoading = false
      }
    },
    handleExport: async function () {
      try {
        this.getSearch()
        const response = await businessIncomeExportList(this.query)
        this.$refs.refExportBtn.exportSaveXlsx(response, '汇总导出')
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    getSearch: function () {
      // let execTimestamp = this.query.exec_timestamp ? moment(this.query.exec_timestamp) : null;
      // if (execTimestamp !== null) {
      //   this.query.begin_timestamp = execTimestamp.format('YYYY-MM') + '-01';
      //   this.query.end_timestamp = execTimestamp.format('YYYY-MM-DD');
      // }
      return this.query
    },
    getTableData: async function (is_search = false) {
      // 查询重置 page
      if (is_search) {
        this.query.page = 1
        this.query.page_size = 20
      }
      this.getSearch()
      this.loading = true
      const response = await businessIncomeList(this.query)
      this.loading = false
      this.tableData = response.model.data || []
      this.query.total = response.model.total || 0
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    handleSelectionChange(val) {
      this.selectedOrders = val
      this.addPreview()
    },
    //预览数据添加
    addPreview() {
      if (this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((row) => {
          const currentIdIndex = this.pageSelectedList.findIndex(value => value.id === row.id)
          if (currentIdIndex === -1) {
            this.pageSelectedList.push({...row})
          }
        })
      }
    },
    //加载订单列表
    getOrdersList() {
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].initList()
    },
    //预览数据-清空
    clearData() {
      this.pageSelectedList = []
      if (this.$refs['refTableIsBiOrder'])
        this.$refs['refTableIsBiOrder'].handleClearSelection()
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY年MM月');
    },
    // 金额格式化
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
  }
};
</script>


<style lang="scss">
.business-income-list-container {
  padding: 5px 10px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .tableCon {
    height: calc(100% - 50px);
    overflow: scroll;
  }
}
</style>
